export function formatBeaconCode(code) {
    return code.toString(8).padStart(4, "0");
}
//# sourceMappingURL=formatBeaconCode.js.map